import React from 'react';
import Header from '../common/header';
import Footer from '../common/footer';
import Service2 from '../layout/service/service2';
import Service1 from '../common/service1';
import Service3 from '../layout/service/service3';
import Servicehead from '../layout/service/servicehead';
import About1 from '../layout/about/about1';


function Service(){
    return(
        <div>
            <Header/>
            <br/>
            <Servicehead/>
            <br/><br/>
            <Service2/>
           
            <br/>
            <Service3/>
            <br/>
            <Footer/>
        </div>
    )
}
export default Service;
